import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const systemApi = createApi({
  reducerPath: 'system',
  baseQuery: createBaseQueryWithReauth('/settings/system'),
  
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1,

  endpoints: (builder) => ({

    // GET: List billing plans
    getSystems: builder.query({
      query: () => ({
      url: `/`,
        method: 'GET',
      }),
      providesTags: ['System'],
    }),

 

    // POST: Updating an existing billing plan
    updateSystem: builder.mutation({
      query: (settings) => ({
        url: `/`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: settings,
      }),
      invalidatesTags: ['System'],
    }),

  }),
});

export const {
  useGetSystemsQuery,
  useUpdateSystemMutation

} = systemApi;
